import { render, staticRenderFns } from "./AdminArticle.vue?vue&type=template&id=1fd01c2e&scoped=true"
import script from "./AdminArticle.vue?vue&type=script&lang=js"
export * from "./AdminArticle.vue?vue&type=script&lang=js"
import style0 from "./AdminArticle.vue?vue&type=style&index=0&id=1fd01c2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd01c2e",
  null
  
)

export default component.exports